export const P100_COVERAGES = {
  PUBLIC_RELATIONS_EXPENSE: {
    name: 'Public Relations Expense',
    tooltip:
      'Coverage for the fees and costs to restore reputation in response to negative publicity following a cyber incident or a security breach. This includes, for example, the fees associated with the hiring of a public relations firm that handles external communications related to the breach.',
    errorMessage: '',
    ordinal: 5,
  },
  RESTORATION_OF_ELECTRONIC_DATA: {
    name: 'Restoration of Electronics Data',
    tooltip:
      'Coverage for the costs to replace or restore electronic data or computer programs in the aftermath of an incident. This can also include the cost of data entry, reprogramming and computer consultation services to restore lost assets.',
    errorMessage: '',
    ordinal: 3,
  },
  POST_BREACH_REMEDIATION: {
    name: 'Post Breach Remediation',
    tooltip:
      'Coverage for labor costs incurred to resolve vulnerabilities or weaknesses in the insured’s computer system that are identified by an independent security firm after a cyber incident. Identified upgrades or improvements must reduce the probability or potential damage of a future incident to qualify.',
    errorMessage: '',
    ordinal: 10,
  },
  SOCIAL_ENGINEERING: {
    name: 'Social Engineering',
    tooltip:
      'Coverage for a loss resulting from a social engineering incident where the insured is intentionally misled to transfer money to a person, place or account directly from good faith reliance upon an instruction transmitted via email by an imposter. A documented verification procedure requirement needs to have been completed in order to be provided coverage.',
    errorMessage: '',
    ordinal: 7,
  },
  PCI_FINES_AND_PENALTIES: {
    name: 'PCI Fines and Penalties',
    tooltip:
      'Coverage for loss and defense expenses as a result of a claim in the form of an action by a Card Company for non-compliance with the Payment Card Industry (PCI) Data Security Standards (DSS), including coverage of related fines or penalties (to the extent such fines or penalties are insurable by law).',
    errorMessage: '',
    ordinal: 13,
  },
  ADDITIONAL_INSURED: {
    name: 'Additional Insureds',
    tooltip: '',
    errorMessage: '',
    ordinal: 18,
  },
  TELECOM_FRAUD: {
    name: 'Telecommunications Fraud',
    tooltip:
      'Coverage for the cost of unauthorized calls or unauthorized use of the insured’s telephone system’s bandwidth, including but not limited to phone bills.',
    errorMessage: '',
    ordinal: 9,
  },
  HARDWARE_REPLACEMENT_COSTS: {
    name: 'Hardware Replacement Costs',
    tooltip:
      'Coverage for the cost to replace computers or any associated devices or equipment operated by the insured that are unable to function as intended due to corruption or destruction of software or firmware, resulting from a cyber incident.',
    errorMessage: '',
    ordinal: 8,
  },
  BI_EXTRA_EXPENSE_V5: {
    name: 'Business Income, Contingent Business Income & Extra Expense',
    tooltip:
      'Coverage for the losses and costs associated with the inability to conduct business due to a cyber incident or an extortion threat. Business income includes net income that would have been earned or incurred. Note that business interruptions due to system failure or voluntary shutdown are not covered.',
    errorMessage: '',
    ordinal: 17,
  },
  EXTORTION_THREATS_AND_RANSOM_PAYMENT: {
    name: 'Extortion Threats & Ransom Payment',
    tooltip:
      'Coverage for loss and defense expenses as a result of an investigation, demand or Regulatory Proceeding, brought by or on behalf of an administrative or regulatory agency, or any federal, state, local or foreign governmental entity in an official capacity.',
    errorMessage: '',
    ordinal: 15,
  },
  COMPUTER_FUNDS_TRANSFER_FRAUD: {
    name: 'Computer & Funds Transfer Fraud',
    tooltip:
      'Coverage for the losses due to a fraudulent computer operation that causes money (or other property) to be transferred from an insured’s account. This also covers losses incurred by a fraudulent instruction directing a financial institution to debit money from the insured’s transfer account.',
    errorMessage: '',
    ordinal: 6,
  },
  SECURITY_BREACH_LIABILITY: {
    name: 'Security Breach Liability',
    tooltip:
      'Coverage for third party liability directly due to a cyber incident and that the insured becomes legally obligated to pay. This includes defense expenses, compensatory damages, and settlement amounts, and fines or penalties assessed against the insured by a regulatory agency or government entity, or for non-compliance with the Payment Card Industry Data Security Standards.',
    errorMessage: '',
    ordinal: 0,
  },
  BI_EXTRA_EXPENSE: {
    name: 'Business Income & Extra Expense',
    tooltip:
      'Coverage for the losses and costs associated with the inability to conduct business due to a cyber incident or an extortion threat. Business income includes net income that would have been earned or incurred. Note that business interruptions due to system failure or voluntary shutdown are not covered.',
    errorMessage: '',
    ordinal: 4,
  },
  EXTORTION_THREATS_AND_RANSOM_PAYMENT_V5: {
    name: 'Extortion Threats & Ransom Payment',
    tooltip:
      'Coverage for loss and defense expenses as a result of an investigation, demand or Regulatory Proceeding, brought by or on behalf of an administrative or regulatory agency, or any federal, state, local or foreign governmental entity in an official capacity.',
    errorMessage: '',
    ordinal: 16,
  },
  REGULATOR_DEFENSE_AND_PENALTIES: {
    name: 'Regulator Defense and Penalties',
    tooltip:
      'Coverage for loss and defense expenses as a result of an investigation, demand or Regulatory Proceeding, brought by or on behalf of an administrative or regulatory agency, or any federal, state, local or foreign governmental entity in an official capacity.',
    errorMessage: '',
    ordinal: 14,
  },
  COURT_ATTENDANCE_COSTS: {
    name: 'Court Attendance Costs',
    tooltip:
      "Coverage for reasonable expenses for attending legal proceedings related to a covered liability claim. This includes required appearances at trials, hearings, mediations, or depositions at the insurer's request. It helps offset the administrative burden of participating in the defense process.",
    errorMessage: '',
    ordinal: 46,
  },
  WEBSITE_MEDIA_CONTENT_LIABILITY: {
    name: 'Website Media Content Liability',
    tooltip:
      'Website Media Liability provides coverage for a loss and defense expenses from intellectual property infringement, other than patent infringement, related to media content on the company website or its social media accounts only.',
    errorMessage: '',
    ordinal: 12,
  },
  SECURITY_BREACH_EXPENSE: {
    name: 'Security Breach Expense',
    tooltip:
      'Coverage for losses and expenses directly associated with recovery activities in the aftermath of a cyber incident. This can include investigation and forensic services, notification to customers, call center services, overtime salaries, post-event monitoring services such as credit monitoring for impacted customers and more',
    errorMessage: '',
    ordinal: 1,
  },
  TRIA: {
    name: 'Certified Acts of Terrorism',
    tooltip: '',
    errorMessage: '',
    ordinal: 19,
  },
  ENHANCED_BUSINESS_AND_CONTINGENT_BUSINESS_INCOME_SYSTEM_FAILURE_INCLUSIVE: {
    name: 'E-Commerce Enhancement & System Failure',
    tooltip:
      'Endorsement that broadens Business Income and Contingent Business Income coverage to businesses that engage in e-commerce and adds a System Failure event trigger.',
    errorMessage: '',
    ordinal: 21,
  },
  ENHANCED_BUSINESS_AND_CONTINGENT_BUSINESS_INCOME: {
    name: 'E-Commerce Enhancement',
    tooltip:
      'Endorsement that broadens Business Income and Contingent Business Income coverage to businesses that engage in e-commerce.',
    errorMessage: '',
    ordinal: 22,
  },
  SERVICE_FRAUD_AND_CRYPTOJACKING: {
    name: 'Service Fraud and Cryptojacking',
    tooltip:
      'Coverage for an expanded set of telecommunications fraud including cloud consumption and cryptojacking',
    errorMessage: '',
    ordinal: 23,
  },
  DEDICATED_BREACH_COSTS_ENDORSEMENT: {
    name: 'Dedicated Breach Costs',
    tooltip:
      'Breach Cost Expense coverage provided as a dedicated separate limit',
    errorMessage: '',
    ordinal: 24,
  },
  EXCLUSION_OF_CONTINGENT_BUSINESS_INCOME: {
    name: 'Exclusion of Contingent Business Income',
    tooltip:
      'Allows Insured to opt for Direct Business Income Only for a premium credit.',
    errorMessage: '',
    ordinal: 25,
  },
  REVERSE_SOCIAL_ENGINEERING_ENDORSEMENT: {
    name: 'Reverse Social Engineering',
    tooltip:
      'Coverage for the fraudulent transfer of funds, including invoice manipulation, or other similar deceptive intentional acts by someone outside Your Organization to Your Client or Vendor',
    errorMessage: '',
    ordinal: 26,
  },
  ADDITIONAL_NAMED_INSURED: {
    name: 'Additional Named Insured',
    tooltip:
      'Additional Named Insureds must be represented in your application for insurance.',
    errorMessage: '',
    ordinal: 27,
  },
};
